module.exports = __webpack_public_path__ + "5b3acc41b21280ea6847492538bedb41.jpg";